import Button, { LinkButton } from '@atlaskit/button/new';

import { FormattedMessage } from 'react-intl';

import { type Button as ButtonType } from '../types';

import { type JSX } from 'react/jsx-runtime';

type TwcModalButtonProps = {
	button: ButtonType;
	onClickAction: (button: ButtonType) => () => void;
};

export const TwcModalButton = ({ button, onClickAction }: TwcModalButtonProps): JSX.Element => {
	switch (button.action) {
		case 'link':
			return (
				<LinkButton
					key={button.id}
					testId={button.testId}
					appearance={button.appearance}
					href={button.href}
					target="_blank"
					onClick={onClickAction(button)}
				>
					<FormattedMessage {...button.message} />
				</LinkButton>
			);
		case 'dismiss':
		case 'takeTour':
			return (
				<Button
					key={button.id}
					testId={button.testId}
					appearance={button.appearance}
					onClick={onClickAction(button)}
				>
					<FormattedMessage {...button.message} />
				</Button>
			);
		default: {
			const _exhaustiveCheck: never = button;
			return _exhaustiveCheck;
		}
	}
};
